import { Navigate } from 'react-router-dom'

import { useNavigation } from 'modules/core/hooks/useNavigation'

const RedirectToResolverTeams = () => {
  const { navigation } = useNavigation()

  return <Navigate to={navigation.settings.ticketing.resolverTeams.fullPath()} replace />
}

export default RedirectToResolverTeams
